var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRange01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "16px",
    height: "17px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "rgb(19, 57, 43)",
    d: "M11.999,16.553 L11.999,14.589 L3.999,14.589 L3.999,16.553 L0.0,16.553 L0.0,10.950 L3.999,7.23 L3.999,13.608 L5.999,13.608 L5.999,9.681 L6.999,9.681 L6.999,13.608 L8.999,13.608 L8.999,9.681 L9.999,9.681 L9.999,13.608 L11.999,13.608 L11.999,7.23 L15.999,10.950 L15.999,16.553 L11.999,16.553 ZM2.999,9.393 L0.999,11.357 L0.999,15.571 L2.999,15.571 L2.999,9.393 ZM14.999,11.357 L12.999,9.393 L12.999,15.571 L14.999,15.571 L14.999,11.357 ZM12.42,5.605 L13.889,3.791 L1.902,3.791 L3.750,5.606 L3.43,6.300 L0.284,3.590 L0.999,2.888 L0.999,2.809 L1.80,2.809 L3.414,0.517 L4.121,1.211 L2.494,2.809 L14.41,2.809 L12.413,1.210 L13.120,0.516 L15.879,3.225 L12.749,6.299 L12.42,5.605 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRange01);
export default __webpack_public_path__ + "static/media/icon_range-01.7e502562018430cdab7d60e2f2a7274c.svg";
export { ForwardRef as ReactComponent };